import React from 'react'
import { AiOutlineFileDone } from 'react-icons/ai'

const testsCompleted = props => {
  return (
    <div className='col-lg-3 column-lmd-2-half column-md-2-full'>
      <div className='icon-box d-flex align-items-center'>
        <div className='icon-element icon-element-bg-5 flex-shrink-0'>
          <AiOutlineFileDone />
        </div>
        <div className='info-content'>
          <h4 className='info__title mb-2'>Testes concluídos</h4>
          <span className='info__count'>{props.data}</span>
        </div>
      </div>
    </div>
  )
}

export default testsCompleted
